import { render, staticRenderFns } from "./ParticipantPromotionHistory.vue?vue&type=template&id=4fa27536&scoped=true"
import script from "./ParticipantPromotionHistory.vue?vue&type=script&lang=js"
export * from "./ParticipantPromotionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa27536",
  null
  
)

export default component.exports